"use client";

import React, { useEffect, useState } from "react";
import { cn } from "../../utils";

export const InfiniteMovingCards = ({
  items,
  direction = "left",
  speed = "fast",
  pauseOnHover = true,
  className,
}) => {
  const containerRef = React.useRef(null);
  const [start, setStart] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      getDirection();
      getSpeed();
      setStart(true);
    }
  }, []);

  const getDirection = () => {
    if (!containerRef.current) return;
    containerRef.current.style.setProperty(
      "--animation-direction",
      direction === "left" ? "forwards" : "reverse"
    );
  };

  const getSpeed = () => {
    if (!containerRef.current) return;
    let duration = "40s";
    if (speed === "fast") duration = "30s";
    else if (speed === "slow") duration = "80s";
    containerRef.current.style.setProperty("--animation-duration", duration);
  };

  return (
    <div
      ref={containerRef}
      className={cn(
        "relative z-20 max-w-full overflow-hidden " +
          "[mask-image:linear-gradient(to_right,transparent,white_10%,white_90%,transparent)]",
        className
      )}
    >
      {/* Heading */}
      <div className="mb-8 text-center px-4">
        <h1 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-violet-800">
          Trusted by Industry Leaders
        </h1>
        <p className="text-gray-700 dark:text-white text-sm sm:text-base mt-3">
          Don&apos;t just take our word for it. See what our valued partners and
          customers say about their experience with Mansafa.
        </p>
      </div>

      {/* Cards strip */}
      <div className="relative flex overflow-hidden">
        <ul
          className={cn(
            "flex shrink-0 flex-nowrap gap-4 py-4 animate-scroll",
            start && "animate-scroll",
            pauseOnHover && "md:hover:[animation-play-state:paused]"
          )}
        >
          {/* First batch */}
          {items.map((item, idx) => (
            <Card key={idx} item={item} />
          ))}
          {/* Duplicate batch for infinite loop */}
          {items.map((item, idx) => (
            <Card key={`dup-${idx}`} item={item} />
          ))}
        </ul>
      </div>
    </div>
  );
};

const Card = ({ item }) => (
  <li
    className="relative w-[85vw] sm:w-[70vw] md:w-[45vw] lg:w-[30vw] 
      max-w-[450px]
      shrink-0 rounded-2xl border border-zinc-200 
      bg-[linear-gradient(180deg,#fafafa,#f5f5f5)] 
      px-6 py-6 shadow-lg
      dark:border-zinc-700 
      dark:bg-[linear-gradient(180deg,#27272a,#18181b)]"
  >
    <blockquote>
      <span className="block text-sm sm:text-base md:text-lg leading-relaxed font-normal text-neutral-800 dark:text-gray-100">
        {item.quote}
      </span>
      <div className="mt-6">
        <span className="block text-sm font-semibold text-neutral-600 dark:text-gray-300">
          {item.name}
        </span>
        <span className="block text-xs sm:text-sm text-neutral-500 dark:text-gray-400">
          {item.title}
        </span>
      </div>
    </blockquote>
  </li>
);
